export default "__VITE_ASSET__RIHxZQXk__"